<template>
  <div class="bhf" id="app">
    <NavBar />

    <div class="bhf__view">
      <router-view :key="$route.path"></router-view>
    </div>
  </div>
</template>

<script>
import NavBar from "./components/NavBar/NavBar";

export default {
  name: "App",
  components: {
    NavBar
  },
  methods: {
    removeTabbingFunction(e) {
      if (e.which === 9) {
        /* tab */ document.documentElement.classList.remove("no-focus-outline");
        document.body.removeEventListener("keyup", this.removeTabbingFunction);
      }
    }
  },
  mounted() {
    document.body.addEventListener("keyup", this.removeTabbingFunction);
  }
};
</script>

<style lang="scss">
@import "./scss/stylesheet.scss";
</style>

<style lang="scss" scoped>
.bhf {
  position: relative;
  width: 100%;
  padding-top: 42px;

  &__view {
    width: 100%;
    position: relative;
  }
}
</style>
